import React from 'react'
import {Heading, HeadingProps} from '@miro-site/core'

interface Props extends HeadingProps {
  children: React.ReactNode
}

const Title: React.FC<Props> = ({children, ...rest}) => {
  return (
    <Heading $variant="h4" $mt={43} $mb={24} {...rest}>
      {children}
    </Heading>
  )
}

export default Title
